// Backend BaseURLs //

//baseUrlLocal // 
// export const baseURL = "http://192.168.1.20:5000/api/v1";

// baseUrl for Development // 
// export const baseURL = "https://one-furever-hzhehmfafegchade.canadacentral-01.azurewebsites.net/api/v1";

// baseUrl for Hosted //
export const baseURL = "https://onefurever-prod-dbbha2bxdjbkcuhh.francecentral-01.azurewebsites.net/api/v1";